module.exports = __webpack_public_path__ + "img/coor-part7.56858a75.png";